import { IGetAccessTokenRequest } from 'store/api/types';

import * as actionTypes from './actionTypes';

export const getAccessTokenRequest = (payload: IGetAccessTokenRequest) => {
    return {
        type: actionTypes.GET_ACCESS_TOKEN_REQUEST,
        payload,
    } as const;
};
